/* Cópia do widget do kit (templates/ewc-bundle) com 4 ajustes LVN: lugar reservado [data-lvn-ofertas], estilo.separador_opcoes, estilo.cor_em_select, gaveta do tema por renderContents() com /?sections=. */
/**
 * ewc-bundle — ofertas por quantidade na página de produto, independente de tema.
 *
 * O widget nasce escondido no fim do body e o JS o leva para logo acima do botão de
 * compra, achando sozinho o formulário de /cart/add que o cliente de fato envia
 * (não o da gaveta, não o do upsell). A partir daí ele intercepta o envio e monta o
 * pedido: as unidades da barra escolhida (cada uma com a variante escolhida), os
 * upsells marcados e os brindes liberados — tudo pelo /cart/add.js.
 *
 * O desconto NÃO é aplicado aqui: o widget mostra a conta que o checkout vai
 * cobrar (a mesma do ofertas.py). Quem cobra é o desconto automático da loja.
 *
 * Falha aberto: qualquer erro deixa a página e o botão do tema como estavam.
 */
(function () {
  'use strict';
  if (window.EwcBundle) return;

  var SEL_PICKER = 'variant-selects,variant-radios,variant-picker,.product-variant-picker,.product-form__variants,[data-product-option],.product-form__input--dropdown,.product-form__input--pill,.product-form__input--swatch';
  var SEL_FORA = 'cart-drawer,.cart-drawer,#shopify-section-cart-drawer,#ewc-cart-root,[data-is-cart-upsell],.upsell,.upsells-container,.drawer,.cart-drawer-upsells-container,.ewc-cart';

  function el(tag, classe, texto) { var n = document.createElement(tag); if (classe) n.className = classe; if (texto != null) n.textContent = texto; return n; }
  function dinheiro(cent, fmt) {
    var v = (cent / 100).toFixed(2), p = v.split('.'), i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/g, i + '.' + p[1]).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, i)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, i.replace(/,/g, '.') + ',' + p[1]).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, i.replace(/,/g, '.')).replace(/<[^>]*>/g, '');
  }
  function enxuto(t) { return String(t).replace(/(\d)\.00(?!\d)/g, '$1'); }
  // preço formatado: os centavos redondos só caem quando `mostrar.sem_decimais` pede
  Widget.prototype.money = function (cent) {
    var s = dinheiro(cent, this.fmt);
    return (this.cfg.mostrar || {}).sem_decimais ? enxuto(s) : s;
  };

  /* ------------------------------------------------------ formulário de compra */
  function achar(root, seletorManual) {
    if (seletorManual) { var m = document.querySelector(seletorManual); if (m) return m; }
    function temBotao(f) { return !!f.querySelector('button[name="add"],[type="submit"]'); }
    function deFora(f) { return !!(f.closest && f.closest(SEL_FORA)); }
    var comId = null, comBotao = null, qualquer = null;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i]; if (deFora(f) || root.contains(f)) continue;
      var id = !!f.querySelector('[name="id"]'), botao = temBotao(f);
      if (id && botao) return f;
      if (id && !comId) comId = f; if (botao && !comBotao) comBotao = f; if (!qualquer) qualquer = f;
    }
    return comBotao || comId || qualquer;
  }
  function posicionar(root, form) {
    // LVN: o template do produto reserva o lugar do bloco de ofertas, como o app ocupava na referência
    var slot = document.querySelector('[data-lvn-ofertas]');
    if (slot) { slot.appendChild(root); root.hidden = false; return true; }
    var alvo = form.querySelector('.product-form__buttons') || form.querySelector('button[name="add"]') || form.querySelector('[type="submit"]') || form;
    if (alvo !== form && alvo.closest) alvo = alvo.closest('.product-form__buttons') || alvo;
    var subir = alvo.closest ? alvo.closest('product-form,.product-form,.product-form__buttons-wrapper') : null;
    if (subir && subir.parentNode && subir !== form.parentNode) alvo = subir;
    if (!alvo.parentNode) return false;
    alvo.parentNode.insertBefore(root, alvo);
    root.hidden = false;
    return true;
  }

  /* ------------------------------------------------------ variantes */
  function Variantes(produto) {
    this.p = produto; this.opcoes = produto.opcoes || []; this.v = produto.variantes || [];
  }
  Variantes.prototype.porOpcoes = function (escolha) {
    for (var i = 0; i < this.v.length; i++) { var ok = true; for (var j = 0; j < escolha.length; j++) if (this.v[i].opcoes[j] !== escolha[j]) { ok = false; break; } if (ok) return this.v[i]; }
    return null;
  };
  Variantes.prototype.valoresDisponiveis = function (indice, prefixo) {
    // valores da opção `indice` que existem (e estão disponíveis) dado o prefixo já escolhido
    var vistos = {}, lista = [];
    for (var i = 0; i < this.v.length; i++) {
      var ok = true; for (var j = 0; j < indice; j++) if (this.v[i].opcoes[j] !== prefixo[j]) { ok = false; break; }
      if (!ok) continue;
      var val = this.v[i].opcoes[indice];
      if (!(val in vistos)) { vistos[val] = false; lista.push(val); }
      if (this.v[i].disponivel) vistos[val] = true;
    }
    return lista.map(function (x) { return { valor: x, disponivel: vistos[x] }; });
  };
  Variantes.prototype.porId = function (id) { for (var i = 0; i < this.v.length; i++) if (String(this.v[i].id) === String(id)) return this.v[i]; return null; };

  /* ------------------------------------------------------ widget */
  function Widget(root) {
    var no = root.querySelector('[data-ewc-bundle-config]');
    var d = JSON.parse(no.textContent);
    this.root = root; this.cfg = d.cfg || {}; this.produto = d.produto; this.fmt = d.moneyFormat; this.rotas = d.rotas || {};
    this.raiz = ((window.Shopify && Shopify.routes && Shopify.routes.root) || this.rotas.raiz || '/').replace(/\/?$/, '/');
    this.vars = new Variantes(this.produto);
    this.barras = this.cfg.barras || [];
    this.selecionada = Math.max(1, Math.min(this.barras.length, parseInt(this.cfg.preselecionada || 1, 10))) - 1;
    this.unidades = [];   // [barraIndex][unidade] = escolha (array de valores de opção)
    this.extras = {};     // dados de produto dos upsells/brindes por handle
    this.ocupado = false;
    this.form = achar(root, this.cfg.seletor_formulario);
    if (!this.form) throw new Error('formulário de compra não encontrado');
    this.aplicarEstilo(); this.montar();
    if (!posicionar(root, this.form)) throw new Error('não achei onde encaixar o widget');
    // quando a barra escolhe a variante, o seletor do tema some junto: deixar os dois
    // na tela é convidar o cliente a pedir uma variante que a barra não vai mandar
    var barraEscolheVariante = this.barras.some(function (b) { return !!b.variante_id; });
    if (this.cfg.esconder_seletor_do_tema !== false && this.vars.v.length > 1 &&
        (this.cfg.variantes_diferentes !== false || barraEscolheVariante)) this.esconderPicker();
    this.ligar(); this.render(); this.carregarExtras();
  }
  /* Cada chave de `estilo` vira uma variavel CSS. Os nomes espelham o que o app de
     bundle guarda no deal (fundo da barra escolhida e da outra, cor do preco, do preco
     riscado, tamanho de cada texto), para a config da loja poder ser copiada 1:1. */
  var ESTILO = {
    cor_destaque: '--eb-acento', cor_selo: '--eb-selo', fundo_barra: '--eb-fundo',
    fundo_selecionada: '--eb-fundo-sel', anel: '--eb-anel', fonte: '--eb-fonte',
    cor_texto: '--eb-texto', cor_suave: '--eb-suave', cor_titulo: '--eb-titulo',
    cor_subtitulo: '--eb-sub', cor_preco: '--eb-preco', cor_preco_cheio: '--eb-preco-cheio',
    fundo_brinde: '--eb-fundo-brinde', anel_brinde: '--eb-anel-brinde',
    fundo_brinde_travado: '--eb-fundo-travado', anel_brinde_travado: '--eb-anel-travado',
    anel_selecionada: '--eb-anel-sel', anel_bolinha: '--eb-anel-bolinha', cor_selo_texto: '--eb-selo-texto',
    peso_subtitulo: '--eb-peso-sub', peso_titulo: '--eb-peso-titulo', peso_preco: '--eb-peso-preco',
    respiro_upsell: '--eb-respiro-upsell', anel_campo: '--eb-anel-campo', caixa_traco: '--eb-caixa-traco',
    cor_brinde_travado: '--eb-cor-travado', fundo_upsell: '--eb-fundo-upsell'
  };
  var ESTILO_PX = {
    raio: '--eb-raio', vao: '--eb-vao', brinde_foto: '--eb-brinde-foto',
    fonte_titulo: '--eb-f-titulo', fonte_subtitulo: '--eb-f-sub', fonte_selo: '--eb-f-selo',
    fonte_preco: '--eb-f-preco', fonte_preco_cheio: '--eb-f-preco-cheio',
    fonte_brinde: '--eb-f-brinde', fonte_upsell: '--eb-f-upsell',
    fonte_titulo_brindes: '--eb-f-titulo-brindes', bolinha: '--eb-bolinha', barra_foto: '--eb-barra-foto',
    foto_raio: '--eb-foto-raio', vao_brindes: '--eb-vao-brindes', raio_campo: '--eb-raio-campo',
    caixa: '--eb-caixa', caixa_raio: '--eb-caixa-raio',
    respiro_topo: '--eb-respiro-topo', foto_upsell: '--eb-foto-upsell'
  };
  Widget.prototype.aplicarEstilo = function () {
    var e = this.cfg.estilo || {}, r = this.root.style;
    Object.keys(ESTILO).forEach(function (k) { if (e[k]) r.setProperty(ESTILO[k], e[k]); });
    Object.keys(ESTILO_PX).forEach(function (k) { if (e[k] != null) r.setProperty(ESTILO_PX[k], e[k] + 'px'); });
    if (e.barras_por_linha) r.setProperty('--eb-colunas', String(e.barras_por_linha));
    if (e.brindes_por_linha) r.setProperty('--eb-colunas-brinde', String(e.brindes_por_linha));
    this.root.classList.toggle('ewc-bundle--empilhado', e.barra_layout === 'empilhado');
    this.root.classList.toggle('ewc-bundle--fita', e.selo_estilo === 'fita');
    this.root.classList.toggle('ewc-bundle--selo-inline', e.selo_estilo === 'inline');
    if (e.css) { var st = el('style'); st.textContent = e.css; this.root.appendChild(st); }
  };
  Widget.prototype.esconderPicker = function () {
    var f = this.form, secao = f.closest('.shopify-section,section,[id^="shopify-section"]') || document;
    secao.querySelectorAll(SEL_PICKER).forEach(function (n) { if (!n.closest('.ewc-bundle')) n.classList.add('ewc-esconde-seletor'); });
  };
  Widget.prototype.variantePadrao = function () {
    var b = this.barras[this.selecionada];
    if (b && b.variante_id) { var fixa = this.vars.porId(b.variante_id); if (fixa) return fixa; }
    var id = this.form.querySelector('[name="id"]'); var v = id && this.vars.porId(id.value);
    if (!v) v = this.vars.v.filter(function (x) { return x.disponivel; })[0] || this.vars.v[0];
    return v;
  };
  Widget.prototype.precoUnitario = function () { var v = this.variantePadrao(); return v ? v.preco : 0; };
  Widget.prototype.compareUnitario = function () { var v = this.variantePadrao(); return v && v.compare > v.preco ? v.compare : 0; };

  Widget.prototype.montar = function () {
    var self = this, cfg = this.cfg;
    this.root.querySelectorAll(':scope > :not(script):not(style)').forEach(function (n) { n.remove(); });  // o <style> do estilo.css fica
    if (cfg.titulo_bloco) this.root.appendChild(el('div', 'ewc-bundle__titulo', cfg.titulo_bloco));
    this.caixaBarras = el('div', 'ewc-bundle__barras');
    this.root.appendChild(this.caixaBarras);
    this.nosBarras = [];
    this.barras.forEach(function (b, i) {
      var lab = el('label', 'ewc-bundle__barra'); lab.setAttribute('data-ewc-bar', i + 1);
      var radio = el('input'); radio.type = 'radio'; radio.name = 'ewc-bundle-bar'; radio.value = String(i);
      lab.appendChild(radio);
      // a etiqueta da barra ('SAVE 40%') fica solta no topo, vira fita, ou entra na
      // linha do título — quem decide é `estilo.selo_estilo`
      var seloNo = b.selo ? el('span', 'ewc-bundle__selo', b.selo) : null;
      var seloNaLinha = (cfg.estilo || {}).selo_estilo === 'inline';
      if (seloNo && !seloNaLinha) lab.appendChild(seloNo);
      var cab = el('div', 'ewc-bundle__cabeca');
      if ((cfg.estilo || {}).bolinha !== 0) cab.appendChild(el('span', 'ewc-bundle__bolinha'));
      // barra que representa um pacote mostra a foto daquele pacote (a foto da variante)
      if ((cfg.estilo || {}).barra_foto && b.imagem) {
        var cx = el('div', 'ewc-bundle__barra-foto'); var fi = el('img'); fi.src = b.imagem; fi.alt = b.titulo || '';
        fi.loading = 'lazy'; cx.appendChild(fi); cab.appendChild(cx);
      }
      var tx = el('div', 'ewc-bundle__textos');
      var nome = el('div', 'ewc-bundle__nome'); nome.textContent = b.titulo || (b.q + ' un');
      if (b.etiqueta) nome.appendChild(el('span', 'ewc-bundle__etiqueta', b.etiqueta));
      if (seloNo && seloNaLinha) nome.appendChild(seloNo);
      tx.appendChild(nome);
      if (b.subtitulo) { var sub = el('div', 'ewc-bundle__sub'); sub.innerHTML = b.subtitulo; tx.appendChild(sub); }
      cab.appendChild(tx);
      var pr = el('div', 'ewc-bundle__precos'); pr.appendChild(el('span', 'ewc-bundle__preco')); pr.appendChild(el('span', 'ewc-bundle__cheio'));
      cab.appendChild(pr); lab.appendChild(cab);
      var un = el('div', 'ewc-bundle__unidades'); lab.appendChild(un);
      var ex = el('div', 'ewc-bundle__extras'); lab.appendChild(ex);
      self.caixaBarras.appendChild(lab);
      self.nosBarras.push({ lab: lab, radio: radio, preco: pr.firstChild, cheio: pr.lastChild, unidades: un, extras: ex });
      self.unidades[i] = [];
    });
    if (this.quadroDeBrindes()) {
      this.noBrindes = el('div', 'ewc-bundle__brindes');
      if (cfg.titulo_brindes) {
        var cabB = el('div', 'ewc-bundle__brindes-cabeca');
        var tit = el('span', 'ewc-bundle__brindes-titulo'); tit.innerHTML = cfg.titulo_brindes;
        cabB.appendChild(tit); this.noBrindes.appendChild(cabB);
      }
      this.listaBrindes = el('div', 'ewc-bundle__brindes-lista');
      this.noBrindes.appendChild(this.listaBrindes);
      this.root.appendChild(this.noBrindes);
    }
    this.propriedade = el('input'); this.propriedade.type = 'hidden'; this.propriedade.name = 'properties[_ewc_bundle]'; this.propriedade.setAttribute('data-ewc-injected', '1');
    this.form.appendChild(this.propriedade);
  };

  /* O preço de uma barra sai SEMPRE do que a vitrine serve, nunca do número gravado
     na config. Numa loja cuja vitrine converte a moeda (base em libra vendendo em
     dólar, por exemplo) o número da config está na moeda base: mostrá-lo com o
     símbolo da moeda do cliente anuncia um preço que o checkout não cobra. A
     porcentagem da barra viaja justamente para a conta poder ser refeita aqui. */
  Widget.prototype.precosDaBarra = function (b) {
    var v = b.variante_id ? this.vars.porId(b.variante_id) : null;
    var unit = v ? v.preco : this.precoUnitario();
    var cmp = v ? (v.compare > v.preco ? v.compare : 0) : this.compareUnitario();
    var total;
    if (unit && b.pct != null) total = Math.round(unit * b.q * (100 - b.pct) / 100);
    else if (unit && !b.desconto_titulo) total = unit * b.q;          // barra sem desconto
    else total = b.total != null ? Math.round(b.total * 100) : unit * b.q;
    return { unidade: unit, compare: cmp, total: total, cada: Math.round(total / b.q) };
  };
  Widget.prototype.render = function () {
    var self = this, cfg = this.cfg;
    this.barras.forEach(function (b, i) {
      var n = self.nosBarras[i], sel = i === self.selecionada;
      n.lab.classList.toggle('is-selected', sel); n.radio.checked = sel;
      var pr = self.precosDaBarra(b), p = pr.unidade, cmp = pr.compare;
      var usarCompare = (cfg.mostrar || {}).usar_compare_at !== false && cmp > 0;
      var total = pr.total, cada = pr.cada;
      var cheioTotal = (usarCompare ? cmp : p) * b.q;
      if ((cfg.mostrar || {}).por_unidade) {
        n.preco.textContent = self.money(cada) + ' each';
        var cheioCada = usarCompare ? cmp : p;
        n.cheio.textContent = cheioCada > cada ? self.money(cheioCada) : '';
      } else {
        n.preco.textContent = self.money(total);
        n.cheio.textContent = cheioTotal > total ? self.money(cheioTotal) : '';
      }
      if (sel) { self.renderUnidades(i); self.renderExtras(i); }
      else { n.unidades.innerHTML = ''; n.extras.innerHTML = ''; }
    });
    this.atualizarForm();
  };

  Widget.prototype.renderUnidades = function (i) {
    var self = this, b = this.barras[i], n = this.nosBarras[i], cont = n.unidades;
    cont.innerHTML = '';
    if (b.variante_id) return;
    if (this.cfg.variantes_diferentes === false || this.vars.v.length <= 1) return;
    var padrao = this.variantePadrao();
    // um rótulo só, com o nome da opção, quando a config pede — é o desenho do app
    var porOpcao = (this.cfg.rotulo_unidades || '') === 'opcao';
    if (porOpcao) cont.appendChild(el('div', 'ewc-bundle__unidades-rotulo', this.vars.opcoes.join((this.cfg.estilo || {}).separador_opcoes || ' · ')));
    // o número da unidade só faz sentido quando há mais de uma para distinguir
    var numerar = !porOpcao || b.q > 1;
    for (var u = 0; u < b.q; u++) {
      if (!this.unidades[i][u]) this.unidades[i][u] = padrao.opcoes.slice();
      var linha = el('div', 'ewc-bundle__unidade');
      if (numerar) linha.appendChild(el('span', 'ewc-bundle__unidade-n', '#' + (u + 1)));
      this.vars.opcoes.forEach(function (nomeOpcao, k) {
        var escolha = self.unidades[i][u];
        var valores = self.vars.valoresDisponiveis(k, escolha);
        var swatch = self.cfg.swatches && self.cfg.swatches.opcao && self.cfg.swatches.opcao.toLowerCase() === String(nomeOpcao).toLowerCase() && self.cfg.swatches.cores;
        var corNoSelect = swatch && (self.cfg.estilo || {}).cor_em_select;
        if (swatch && !corNoSelect) {
          var grupo = el('div', 'ewc-bundle__swatches'); grupo.setAttribute('role', 'radiogroup'); grupo.setAttribute('aria-label', nomeOpcao);
          valores.forEach(function (x) {
            var s = el('span', 'ewc-bundle__swatch'); s.title = x.valor; s.style.background = self.cfg.swatches.cores[x.valor] || '#ccc';
            s.classList.toggle('is-on', escolha[k] === x.valor); s.classList.toggle('is-off', !x.disponivel);
            s.setAttribute('data-ewc-opt', k); s.setAttribute('data-ewc-val', x.valor); s.setAttribute('data-ewc-un', u);
            grupo.appendChild(s);
          });
          linha.appendChild(grupo);
        } else {
          var s = el('select'); s.setAttribute('data-ewc-opt', k); s.setAttribute('data-ewc-un', u); s.setAttribute('aria-label', nomeOpcao);
          valores.forEach(function (x) { var o = el('option', null, x.valor + (x.disponivel ? '' : ' (Sold out)')); o.value = x.valor; o.disabled = !x.disponivel; s.appendChild(o); });
          s.value = escolha[k];
          if (corNoSelect) {
            var caixa = el('span', 'ewc-bundle__cor-caixa');
            var ponto = el('span', 'ewc-bundle__cor-ponto'); ponto.style.background = swatch[escolha[k]] || '#ccc';
            caixa.appendChild(ponto); caixa.appendChild(s); linha.appendChild(caixa);
          } else linha.appendChild(s);
        }
      });
      cont.appendChild(linha);
    }
  };

  Widget.prototype.renderExtras = function (i) {
    var self = this, n = this.nosBarras[i], cont = n.extras; cont.innerHTML = '';
    var ups = (this.cfg.upsells || []).filter(function (u) { return !u.por_barra || !u.por_barra.length || u.por_barra.indexOf(i + 1) !== -1; });
    ups.forEach(function (u) {
      // duas partes, como no app: a linha do produto e o bloco de preço. Numa barra
      // estreita o preço desce sozinho para a segunda linha.
      var linha = el('label', 'ewc-bundle__extra');
      var principal = el('div', 'ewc-bundle__extra-main');
      var cb = el('input'); cb.type = 'checkbox'; cb.setAttribute('data-ewc-upsell', u.handle);
      cb.checked = !!u.pre_marcado || (self.marcados && self.marcados[u.handle] === true);
      principal.appendChild(cb);
      var d = self.extras[u.handle];
      if (d && d.imagem) { var im = el('img'); im.src = d.imagem; im.alt = ''; principal.appendChild(im); }
      principal.appendChild(el('span', 'ewc-bundle__extra-txt', u.texto || (d ? d.titulo : u.handle)));
      linha.appendChild(principal);
      var precos = el('div', 'ewc-bundle__extra-preco');
      if (u.gratis) {
        precos.appendChild(el('span', 'ewc-bundle__extra-gratis', u.rotulo || self.money(0)));
        var risc = self.riscadoDe(u, d);
        if (risc) precos.appendChild(el('span', 'ewc-bundle__cheio', self.money(risc)));
      } else if (d) precos.appendChild(el('span', 'ewc-bundle__extra-gratis', self.money(d.preco)));
      linha.appendChild(precos); cont.appendChild(linha);
    });
    if (this.quadroDeBrindes()) { this.renderQuadroDeBrindes(i); return; }
    (this.cfg.brindes || []).forEach(function (g) {
      var livre = (i + 1) >= (g.a_partir_da_barra || 1);
      var linha = el('div', 'ewc-bundle__extra' + (livre ? '' : ' is-locked')); linha.setAttribute('data-ewc-gift', g.handle);
      var d = self.extras[g.handle];
      if (d && d.imagem) { var im = el('img'); im.src = d.imagem; im.alt = ''; linha.appendChild(im); }
      var txt = el('span', null, (d ? d.titulo : g.handle) + ' ');
      txt.appendChild(el('span', 'ewc-bundle__extra-gratis', livre ? (g.rotulo || 'FREE') : (self.cfg.textos && self.cfg.textos.travado || 'Locked')));
      if (d && d.compare) txt.appendChild(el('span', 'ewc-bundle__cheio', self.money(d.compare)));
      linha.appendChild(txt); cont.appendChild(linha);
    });
  };

  Widget.prototype.quadroDeBrindes = function () {
    return this.cfg.brindes_layout === 'quadro' && (this.cfg.brindes || []).length > 0;
  };

  /* O quadro de brindes da referencia: uma fileira de cartoes abaixo das barras,
     cada um com foto, nome, a palavra FREE e o preco de tabela riscado. */
  Widget.prototype.renderQuadroDeBrindes = function (i) {
    var self = this, lista = this.listaBrindes;
    if (!lista) return;
    lista.innerHTML = '';
    (this.cfg.brindes || []).forEach(function (g) {
      var livre = (i + 1) >= (g.a_partir_da_barra || 1);
      var d = self.extras[g.handle];
      var cartao = el('div', 'ewc-bundle__brinde' + (livre ? '' : ' is-locked'));
      cartao.setAttribute('data-ewc-gift', g.handle);
      // o selo fica por cima da borda de cima do cartao, centrado
      var selo = el('div', 'ewc-bundle__brinde-selo');
      selo.appendChild(el('span', 'ewc-bundle__brinde-selo-txt', livre ? (g.rotulo || 'FREE') : (self.cfg.textos && self.cfg.textos.travado || 'Locked')));
      var risc = self.riscadoDe(g, d) || (d && (d.compare || d.preco));
      if (risc) selo.appendChild(el('span', 'ewc-bundle__brinde-selo-cheio', self.money(risc)));
      cartao.appendChild(selo);
      var foto = el('div', 'ewc-bundle__brinde-foto');
      if (d && d.imagem) { var im = el('img'); im.src = d.imagem; im.alt = d.titulo || ''; foto.appendChild(im); }
      cartao.appendChild(foto);
      cartao.appendChild(el('div', 'ewc-bundle__brinde-nome', d ? d.titulo : g.handle));
      lista.appendChild(cartao);
    });
  };

  /* `riscado` diz QUAL preço mostrar cortado, não qual número: "tabela" é o preço de
     tabela do produto de origem e "preco" é o preço dele — os dois lidos da vitrine, que
     entrega tudo na moeda que o cliente está vendo. Número solto na config continua
     aceito, e vale onde a vitrine não converte. */
  Widget.prototype.riscadoDe = function (x, d) {
    var r = x.riscado;
    if (typeof r === 'string' && r && x.origem) {
      var o = this.extras[x.origem];
      if (!o) return 0;
      return r === 'tabela' ? (o.compare || o.preco) : o.preco;
    }
    if (r != null && r !== '') return Math.round(r * 100);
    return (d && d.compare) || 0;
  };
  Widget.prototype.carregarExtras = function () {
    var self = this, handles = [];
    (this.cfg.upsells || []).concat(this.cfg.brindes || []).forEach(function (x) {
      if (x.handle && handles.indexOf(x.handle) === -1) handles.push(x.handle);
      // o upsell risca o preço de tabela do produto ORIGINAL: esse número tem que vir da
      // vitrine também, senão não acompanha a moeda que o cliente está vendo
      if (x.origem && typeof x.riscado === 'string' && handles.indexOf(x.origem) === -1) handles.push(x.origem);
    });
    handles.forEach(function (h) {
      fetch(self.raiz + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
        self.extras[h] = { titulo: p.title, preco: v ? v.price : 0, compare: v && v.compare_at_price > v.price ? v.compare_at_price : (v && v.price === 0 && v.compare_at_price ? v.compare_at_price : 0),
                           variante: v ? v.id : null, imagem: (p.featured_image || '').replace(/(\.[a-z]+)(\?.*)?$/i, '_300x300$1$2') };
        self.renderExtras(self.selecionada);
      }).catch(function () {});
    });
  };

  Widget.prototype.itens = function () {
    var b = this.barras[this.selecionada], contagem = {}, ordem = [];
    var padrao = this.variantePadrao();
    if (b.variante_id) {
      contagem[b.variante_id] = b.q; ordem.push(b.variante_id);
    } else for (var u = 0; u < b.q; u++) {
      var v = (this.cfg.variantes_diferentes === false || this.vars.v.length <= 1) ? padrao : (this.vars.porOpcoes(this.unidades[this.selecionada][u] || padrao.opcoes) || padrao);
      if (!(v.id in contagem)) { contagem[v.id] = 0; ordem.push(v.id); }
      contagem[v.id]++;
    }
    var itens = ordem.map(function (id) { return { id: parseInt(id, 10), quantity: contagem[id], properties: { _ewc_bundle: b.titulo || String(b.q) } }; });
    var self = this;
    this.root.querySelectorAll('[data-ewc-upsell]:checked').forEach(function (cb) {
      var h = cb.getAttribute('data-ewc-upsell'), d = self.extras[h];
      if (d && d.variante) itens.push({ id: d.variante, quantity: 1, properties: { _ewc_upsell: '1' } });
    });
    (this.cfg.brindes || []).forEach(function (g) {
      if ((self.selecionada + 1) < (g.a_partir_da_barra || 1)) return;
      var vid = g.variante_id || (self.extras[g.handle] && self.extras[g.handle].variante);
      if (vid) itens.push({ id: parseInt(vid, 10), quantity: 1, properties: { _ewc_gift: '1' } });
    });
    return itens;
  };

  Widget.prototype.atualizarForm = function () {
    var b = this.barras[this.selecionada]; this.propriedade.value = b.titulo || String(b.q);
    var distintos = {}; this.itens().forEach(function (i) { if (!i.properties._ewc_upsell && !i.properties._ewc_gift) distintos[i.id] = 1; });
    var multi = Object.keys(distintos).length > 1 || b.q > 1;
    this.form.classList.toggle('ewc-multi-variant', multi && this.cfg.esconder_expresso !== false);
    var sec = this.form.closest('.shopify-section,section'); if (sec) sec.classList.toggle('ewc-multi-variant', multi && this.cfg.esconder_expresso !== false);
    var bd = this.cfg.botao_dinamico;
    if (bd && bd.modelo) {
      var btn = this.form.querySelector('button[name="add"],[type="submit"]');
      var alvo = btn && (btn.querySelector('span') || btn);
      if (alvo) {
        if (!btn.hasAttribute('data-ewc-texto-original')) btn.setAttribute('data-ewc-texto-original', alvo.textContent);
        var pr = this.precosDaBarra(b);
        var cheio = (pr.compare || pr.unidade) * b.q;
        var economia = Math.max(0, cheio - pr.total);
        var novo = economia > 0 ? bd.modelo.replace('{{economia}}', this.money(economia)) : btn.getAttribute('data-ewc-texto-original');
        if (alvo.textContent !== novo) alvo.textContent = novo;
      }
    }
  };

  Widget.prototype.ligar = function () {
    var self = this;
    this.root.addEventListener('change', function (ev) {
      var t = ev.target;
      if (t.name === 'ewc-bundle-bar') { self.selecionada = parseInt(t.value, 10); self.render(); return; }
      if (t.tagName === 'SELECT' && t.hasAttribute('data-ewc-opt')) {
        var k = parseInt(t.getAttribute('data-ewc-opt'), 10), u = parseInt(t.getAttribute('data-ewc-un'), 10);
        var esc = self.unidades[self.selecionada][u]; esc[k] = t.value;
        for (var j = k + 1; j < self.vars.opcoes.length; j++) { var vals = self.vars.valoresDisponiveis(j, esc); if (!vals.some(function (x) { return x.valor === esc[j]; })) esc[j] = (vals.filter(function (x) { return x.disponivel; })[0] || vals[0] || {}).valor; }
        self.renderUnidades(self.selecionada); self.atualizarForm(); return;
      }
      if (t.hasAttribute('data-ewc-upsell')) { self.marcados = self.marcados || {}; self.marcados[t.getAttribute('data-ewc-upsell')] = t.checked; self.atualizarForm(); }
    });
    this.root.addEventListener('click', function (ev) {
      var s = ev.target.closest && ev.target.closest('.ewc-bundle__swatch'); if (!s) return;
      ev.preventDefault();
      var k = parseInt(s.getAttribute('data-ewc-opt'), 10), u = parseInt(s.getAttribute('data-ewc-un'), 10);
      self.unidades[self.selecionada][u][k] = s.getAttribute('data-ewc-val');
      self.renderUnidades(self.selecionada); self.atualizarForm();
    });
    this.form.addEventListener('submit', function (ev) {
      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation(); self.comprar();
    }, true);
    this.form.setAttribute('data-ewc-bundle-form', '1');
    var self2 = this; window.addEventListener('pageshow', function () { self2.ocupado = false; var btn = self2.form.querySelector('button[name="add"],[type="submit"]'); if (btn) btn.disabled = false; });
  };

  Widget.prototype.comprar = function () {
    var self = this; if (this.ocupado) return; this.ocupado = true;
    var btn = this.form.querySelector('button[name="add"],[type="submit"]'); if (btn) btn.disabled = true;
    var itens = this.itens();
    fetch(this.raiz + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: itens }) })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function (json) {
        document.dispatchEvent(new CustomEvent('ewc:cart:added', { bubbles: true, detail: { items: json.items || [json] } }));
        var depois = self.cfg.depois_de_adicionar || 'gaveta';
        // LVN: a gaveta do tema da referência se redesenha e abre por refreshContents()
        var gav = document.querySelector('cart-drawer');
        if (depois === 'gaveta' && !window.EwcCart && gav && typeof gav.renderContents === 'function') {
          // seções renderizadas pela rota da loja (com Accept json, /cart devolve o carrinho e não as seções)
          return fetch((self.raiz || '/') + '?sections=cart-drawer,cart-icon-bubble')
            .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
            .then(function (sections) { gav.renderContents({ sections: sections }, { open: true }); if (gav.open && !gav.classList.contains('active')) gav.open(); })
            .catch(function () { window.location.href = self.rotas.carrinho || (self.raiz + 'cart'); });
        }
        if (depois === 'carrinho' || (depois === 'gaveta' && !window.EwcCart)) {
          ['cart:refresh', 'cart:build', 'cart-drawer:open', 'ajaxProduct:added'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); });
          if (depois === 'carrinho' || !document.querySelector('cart-drawer,.cart-drawer,[data-cart-drawer]')) window.location.href = self.rotas.carrinho || (self.raiz + 'cart');
        }
      })
      .catch(function () { window.location.href = self.rotas.carrinho || (self.raiz + 'cart'); })
      .then(function () { self.ocupado = false; if (btn) btn.disabled = false; });
  };

  function iniciar() {
    document.querySelectorAll('[data-ewc-bundle]').forEach(function (root) {
      if (root._ewc) return;
      try { root._ewc = new Widget(root); window.EwcBundle = root._ewc; } catch (e) { root.hidden = true; if (window.console && console.debug) console.debug('[ewc-bundle] fora do ar:', e.message); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
